import React from 'react';
import { ApiError } from '../api/api';
import { Alert } from './Alert';

type Props = {
  error: ApiError;
  genericErrorMessage?: string;
  title?: string;
  className?: string;
};

export const errorBoxTestId = 'error-box';

export const ErrorBox = ({ error, genericErrorMessage, title, className }: Props) => {
  return (
    <Alert
      type="error"
      title={title}
      body={error.userVisibleMessage || genericErrorMessage || 'An unknown error occurred'}
      className={className}
      data-testid={errorBoxTestId}
    />
  );
};
